"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import inputStyles from "../input/input.module.css";
import styles from "./select.module.css";
export function Select(_a) {
    var _b, _c;
    var className = _a.className, children = _a.children, focused = _a.focused, error = _a.error, onFocus = _a.onFocus, onBlur = _a.onBlur, rest = __rest(_a, ["className", "children", "focused", "error", "onFocus", "onBlur"]);
    var _d = __read(useState(focused), 2), isFocused = _d[0], setIsFocused = _d[1];
    var errors = Array.isArray(error) ? error : error ? [error] : [];
    useEffect(function () {
        setIsFocused(focused);
    }, [focused]);
    return (_jsx("div", { className: classNames(styles["container"], inputStyles["container"], (_b = {},
            _b[inputStyles["has-error"]] = errors.length > 0,
            _b)), children: _jsx("select", __assign({}, rest, { className: classNames(styles["select"], inputStyles["input"], className, (_c = {},
                _c[styles["focused"]] = isFocused,
                _c)), onFocus: handleOnFocus, onBlur: handleOnBlur, children: children })) }));
    function handleOnFocus(event) {
        setIsFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    }
    function handleOnBlur(event) {
        setIsFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }
}
